function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentAnalysisNav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.7523 10.725L16.4523 14.475C16.3398 15.6225 16.2498 16.5 14.2173 16.5H4.78232C2.74982 16.5 2.65982 15.6225 2.54732 14.475L2.24732 10.725C2.18732 10.1025 2.38232 9.52498 2.73482 9.08248C2.74232 9.07498 2.74232 9.07498 2.74982 9.06748C3.16232 8.56498 3.78482 8.24998 4.48232 8.24998H14.5173C15.2148 8.24998 15.8298 8.56498 16.2348 9.05248C16.2423 9.05998 16.2498 9.06748 16.2498 9.07498C16.6173 9.51748 16.8198 10.095 16.7523 10.725Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.125 8.5725V4.71C3.125 2.16 3.7625 1.5225 6.3125 1.5225H7.265C8.2175 1.5225 8.435 1.8075 8.795 2.2875L9.7475 3.5625C9.9875 3.8775 10.13 4.0725 10.7675 4.0725H12.68C15.23 4.0725 15.8675 4.71 15.8675 7.26V8.6025",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57251 12.75H11.4275",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAnalysisNav);
export default __webpack_public_path__ + "static/media/document-analysis-nav.b6a0a70c1f55c1589f42bec25c907274.svg";
export { ForwardRef as ReactComponent };